import { colorPalette } from './palette/colorPalette'
import { typographyHeadings } from './palette/typographyHeadings'
import { typographyBody } from './palette/typographyBody'

/** MUI palette, typography, and shape — values unchanged from legacy muiTheme monolith. */
export const themeOptions = {
  palette: colorPalette,
  typography: {
    fontFamily: 'var(--app-font-sans)',
    htmlFontSize: 16,
    fontSize: 12,
    ...typographyHeadings,
    ...typographyBody,
  },
  shape: {
    borderRadius: 10,
  },
}

export default themeOptions
